module.exports = __webpack_public_path__ + "img/jameson-5.30b8851f.png";